import { ArrivalWindow } from '../../../common/arrivalWindow'

const defaultChoiceOrder = [
  ArrivalWindow.from8to9,
  ArrivalWindow.from9to10,
  ArrivalWindow.from7to8,
  ArrivalWindow.from13to15,
  ArrivalWindow.from16to19,
]

export const useGetDefaultTime = () => (availableTime: ArrivalWindow[], preferredTime: ArrivalWindow[]) => {
  return preferredTime.find(t => availableTime.includes(t)) ??
    defaultChoiceOrder.find(t => availableTime.includes(t)) ??
    ArrivalWindow.from8to9
}
